var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{domProps:{"textContent":_vm._s(_vm.product.type)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.product.brand)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.product.model)}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ProductListElement.vue?vue&type=template&id=3338ec9e
// module id = GHCu
// module chunks = 1